<template>
<div class="chapter">
<div class="inner_page">
<p class="centers" id="fm01"><a id="page_1"></a>Praise for <em>Your Nutrition Solution to a Healthy Gut</em>:</p>
<p class="indent">“Sound nutrition advice from a nutrition expert. Filled with practical nutrition tips and tidbits for optimizing gut health, Ms. Tessmer’s book is a terrific manual for anyone with or without digestive troubles who is interested in eating their way to optimal health.”</p>
<p class="textright">—Colleen D. Webb, MS, RDN, CLT</p>
<p class="indent">“<em>Your Nutrition Solution to a Healthy Gut</em> contains a wealth of information that will improve your gut health, written in an easy to understand and easy to follow format. Kimberly’s food lists and suggestions are practical and easy to incorporate into daily living and her nutrition solution tidbits throughout the book help to drive the message home. This is a must read for anyone who has suffered from poor gut health or wants to continue maintaining a healthy gut.”</p>
<p class="textright">—Lisa Davis, RDN, Clinical Dietitian, Henrico Doctors’ Hospital</p>
<p class="indent">“Kim has used a basic, easy-to-read and -understand approach to educate the reader on gut health. Her food choices and meal plan suggestions are clearly outlined and easy to follow.”</p>
<p class="textright">—Johanna Donnenfield, BSc, Phm, MS, RD</p>
<p class="indent"><a id="page_2"></a>“<em>Your Nutrition Solution to a Healthy Gut</em> has the answers to all your ‘gut health’ questions. From explaining what the gut actually is, to understanding the various conditions/diseases associated with the gut through how to eat and shop for foods that support a healthy gut, Kim Tessmer has outdone herself with this book. It is written in an easy to understand fashion with actionable steps to get you started right away. The 14-day menu and shopping guide will make implementation easy, without overwhelm.”</p>
<p class="textright">—Bonnie R. Giller, MS, RD, CDN, CDE</p>
<p class="indent">“Wish you knew all your dietitian did about eating for gut health? If so, this book is for you. Apply what’s here and save yourself a lot of money and misery. ‘Gut Health’ is a complex topic, but it’s nicely covered, in layman language with many expert suggestions you can apply today.”</p>
<p class="textright">—Jan Patenaude, RD, CLT</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?6c43823c